module.exports = __webpack_public_path__ + "img/TULogo_RGB.be0d6025.svg";